import React, { useRef, useEffect } from 'react'
import "./BottomSection.css"
import SuitcaseEnd from '../../components/SuitcaseEnd';
import { useInView } from "framer-motion";
// import SuitcaseEnterComponent from '../../components/SuitcaseEnterComponent';
import ReactGA from 'react-ga4';

const BottomSection = ({ children }) => {

    const suitcaseRef = useRef(null);
    const isInView = useInView(suitcaseRef, { once: false });

    //Track Button Clicks with Google Analytics
    const trackWebsiteVisitClick = (e) => {
        ReactGA.event({
            category: 'Button',
            action: 'Click',
            label: 'Got To Tripadvisor Website',
            value: 1
        });
    };

    //Track Twitter Clicks with Google Analytics
    const trackTwitterClick = (e) => {
        ReactGA.event({
            category: 'Button',
            action: 'Click',
            label: 'Got To Twitter Website',
            value: 1
        });
    };


    //Track Facebook Clicks with Google Analytics
    const trackFacebookClick = (e) => {
        ReactGA.event({
            category: 'Button',
            action: 'Click',
            label: 'Got To Facebook Website',
            value: 1
        });
    };

    //Track Instagram Clicks with Google Analytics
    const trackInstagramClick = (e) => {
        ReactGA.event({
            category: 'Button',
            action: 'Click',
            label: 'Got To Instagram Website',
            value: 1
        });
    };








useEffect(() => {

},[]);

return (
<div className='uk-section'>
    <div className='uk-container uk-container-small uk-margin-auto uk-margin-top uk-margin-remove-bottom'>
        <div className='uk-width-1-1 uk-text-center' >
                <div uk-scrollspy="target: [uk-scrollspy-class]; cls: uk-animation-slide-bottom-small; delay: 0; repeat: true;">

                    <div className='trip-heading-one trip-ultra uk-margin-bottom uk-animation-slide-' uk-scrollspy-class="uk-animation-slide-bottom-medium">
                        So…where to next?
                    </div>

                    <div uk-scrollspy-class="uk-animation-slide-top-medium">
                        <a href='https://tripadvisor.com' target="_blank" className='uk-button uk-button-large uk-button-default button-trip-green' rel='noreferrer' onClick={trackWebsiteVisitClick}>
                                Let's go
                        </a>
                    </div>

                </div>

                <div>
                    {/* <div ref={suitcaseRef}
                                style={{
                                    transform: isInView ? "none" : "translateY(200px)",
                                    opacity: isInView ? 1 : 0,
                                    transition: " 0.5s"
                                }}
                                
                                className="uk-margin-top"> 
                    </div> */}

                    <div 
                    ref={suitcaseRef}
                    style={{
                        transform: isInView ? "none" : "translateY(200px)",
                        opacity: isInView ? 1 : 0,
                        transition: " 0.5s"
                    }}
                    
                    className="uk-margin-top suitcase-small uk-margin-auto">
                        <SuitcaseEnd /> 
                        
                    </div>

                    <div className='' uk-scrollspy="target: [uk-scrollspy-class]; cls: uk-animation-slide-bottom-small; delay: 200; offset-top: 100; repeat: false;">
                          <a href="https://www.twitter.com/tripadvisor/" rel="noreferrer" className="uk-icon-button uk-margin-small-right" uk-icon="twitter" target="_blank" onClick={ trackTwitterClick } uk-scrollspy-class="uk-animation-slide-bottom-medium"> </a>
                          <a href="https://www.facebook.com/Tripadvisor/" rel="noreferrer" className="uk-icon-button  uk-margin-small-right" uk-icon="facebook" target="_blank" onClick={ trackFacebookClick } uk-scrollspy-class="uk-animation-slide-bottom-medium"> </a>
                          <a href="https://www.instagram.com/tripadvisor/" rel="noreferrer" className="uk-icon-button" uk-icon="instagram" target="_blank" onClick={ trackInstagramClick } uk-scrollspy-class="uk-animation-slide-bottom-medium"> </a>
                    </div>

                </div>

        </div>
    </div>
</div>
  )
}

export default BottomSection